import type { FC } from 'react'

import { Skeleton } from '@/components/ui/skeleton.tsx'

export interface Props {}

export const MediaSkeleton: FC<Props> = () => (
  <Skeleton className="relative mb-0.5 mr-0.5 aspect-square w-full overflow-hidden dark:bg-neutral-800" />
)
